export interface CoberturaDePara {
  mapeadas: number;
  total: number;
  pendentes: number;
  /** 0–100, arredondado; mesma base do indicador "Contas mapeadas". */
  percentual: number;
}

/** Fonte única do indicador de cobertura do De/Para: o número e a barra de progresso leem o mesmo valor. */
export const calcularCobertura = (mapeadas: number, total: number): CoberturaDePara => {
  const pct = total > 0 ? Math.round((mapeadas / total) * 100) : 0;
  return { mapeadas, total, pendentes: Math.max(0, total - mapeadas), percentual: Math.min(100, Math.max(0, pct)) };
};
